import styled from "@emotion/styled";
import { Box, Divider, Paper } from "@mui/material";

export const ClientePaperContainer = styled(Paper)`
    margin-top: 1rem;
    padding: 0.2rem 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
`

export const DividerEndereco = styled(Divider)`
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    width: 100%;
`

export const ClienteBox = styled(Box)`
    width: 100%;
    display: flex;
    align-items: center;
    height: 80px;
`

export const DadosClienteBox = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const AvatarBox = styled(Box)`
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 0.7rem;
`

export const EnderecoBox = styled(Box)`
    width: 100%;
`